import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { FlexCol, FlexRow } from '@/components/ui/flex';
import { Text } from '@/components/ui/text';
import { useSharedKnowledgeGroupsService } from '@/services/sharedFiles';
import { useState, type FC } from 'react';
import { CreateEditGroupModal } from './CreateEditGroupModal';
import { DeleteGroupModal } from './DeleteGroupModal';

export const ManageGroupsModal: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { groups } = useSharedKnowledgeGroupsService();
  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="outline">Manage Knowledge Groups</Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[512px]">
        <DialogHeader>
          <DialogTitle>Manage Knowledge Groups</DialogTitle>
          <DialogDescription>
            Add, edit, or remove knowledge groups for your shared knowledge
            documents.
          </DialogDescription>
        </DialogHeader>
        <FlexCol gap="3" className="max-h-[512px] overflow-y-auto">
          {groups.map(group => (
            <FlexRow
              key={group.id}
              p="3"
              w="full"
              br="lg"
              alignItems="center"
              gap="2"
              justifyContent="between"
              className="border border-neutral-200 bg-secondary"
            >
              <Text>{group.name}</Text>
              <FlexRow alignItems="center">
                <CreateEditGroupModal
                  mode="edit"
                  id={group.id}
                  name={group.name}
                  uname={group.uname}
                  description={group.description}
                  regions={group.regions}
                />
                <DeleteGroupModal groupId={group.id} />
              </FlexRow>
            </FlexRow>
          ))}
        </FlexCol>
        <DialogFooter>
          <CreateEditGroupModal mode="create" />
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
